module.exports = __webpack_public_path__ + "img/BPS.4c0c103c.png";